import { FC, useState } from "react";
import { UserIdsTable } from "entities/wheel-raffle";
import type { RafflePublicLists } from "entities/wheel-raffle";
import { Pager, Tabs } from "shared/ui";
import { RAFFLES_PER_PAGE } from "../../model/constants";
import { useClientPage } from "../../model/useClientPage";
import { getPeopleTabs } from "./peopleTabs";
import type { PeopleTab } from "./peopleTabs";

import styles from "./RaffleDetailPage.module.css";

interface Props {
  // undefined — бэк не прислал списки (старый ответ).
  lists?: RafflePublicLists;
  // Итоги показываем после остановки колеса, а не сразу после draw.
  isDrawn: boolean;
}

const FidList: FC<{ fids: number[]; emptyText: string }> = ({
  fids,
  emptyText,
}) => {
  const { pageItems, page, pages, setPage } = useClientPage(fids);

  if (!fids.length) return <p className={styles.placeholder}>{emptyText}</p>;
  return (
    <>
      <div className={styles.table}>
        <UserIdsTable fids={pageItems} offset={(page - 1) * RAFFLES_PER_PAGE} />
      </div>
      <Pager page={page} pages={pages} onChange={setPage} />
    </>
  );
};

// Для не-организатора: победители и участники из detail (v2), только fid.
export const PublicPeople: FC<Props> = ({ lists, isDrawn }) => {
  // После розыгрыша важнее победители — открываем их первыми.
  const [tab, setTab] = useState<PeopleTab>(
    isDrawn ? "winners" : "participants",
  );
  const participants = lists?.participant_fids ?? [];
  const winners = lists?.winner_fids ?? [];

  const renderBody = () => {
    if (!lists) {
      return (
        <p className={styles.placeholder}>The list is not available yet.</p>
      );
    }
    return tab === "winners" ? (
      <FidList key="winners" fids={winners} emptyText="No winners" />
    ) : (
      <FidList
        key="participants"
        fids={participants}
        emptyText="No participants yet"
      />
    );
  };

  return (
    <>
      <Tabs
        items={getPeopleTabs(
          isDrawn,
          participants.length,
          lists ? winners.length : null,
        )}
        active={tab}
        onChange={setTab}
        tabClassName={styles.pill}
        activeClassName={styles.pillActive}
      />
      {renderBody()}
    </>
  );
};
